// extracted by mini-css-extract-plugin
module.exports = {"lockIcon":"NationalitySelector_lockIcon__NhGY_"};